var map = {
	"./marker_big_blue.png": "300d",
	"./marker_big_green.png": "9b82",
	"./marker_big_orange.png": "327c",
	"./marker_big_red.png": "358e",
	"./marker_small_blue.png": "2d0e",
	"./marker_small_green.png": "8e96",
	"./marker_small_orange.png": "6392",
	"./marker_small_red.png": "a6c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47b6";